/**
 * @generated SignedSource<<f4b6216cd1e7cb7c21b4f39fe0d263b1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PipelinesSidebarContentQuery$variables = Record<PropertyKey, never>;
export type PipelinesSidebarContentQuery$data = {
  readonly pipelinesRest: {
    readonly " $fragmentSpreads": FragmentRefs<"PipelinesSidebarFragment">;
  } | null | undefined;
};
export type PipelinesSidebarContentQuery = {
  response: PipelinesSidebarContentQuery$data;
  variables: PipelinesSidebarContentQuery$variables;
};

const node: ConcreteRequest = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PipelinesSidebarContentQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Pipelines",
        "kind": "LinkedField",
        "name": "pipelinesRest",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PipelinesSidebarFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PipelinesSidebarContentQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Pipelines",
        "kind": "LinkedField",
        "name": "pipelinesRest",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PipelineRest",
            "kind": "LinkedField",
            "name": "pipeline",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "_id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1dfc7526412d29cbd5de4768e9a3620b",
    "id": null,
    "metadata": {},
    "name": "PipelinesSidebarContentQuery",
    "operationKind": "query",
    "text": "query PipelinesSidebarContentQuery {\n  pipelinesRest {\n    ...PipelinesSidebarFragment\n  }\n}\n\nfragment PipelinesSidebarFragment on Pipelines {\n  pipeline {\n    name\n    id\n    _id\n  }\n}\n"
  }
};

(node as any).hash = "15e6ae188d62aa247ba04a2612a2a931";

export default node;
